/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import TenantsAdmin from "../../components/TenantsAdmin/TenantsAdmin";
import { fetchTenant } from "../../store/slices/tenants-admin";
import { tenantsAdminData } from "../../components/TenantsAdmin/TenantsAdminInterfaces";
import LocalStorageService from "../../services/LocalStorageService";
import { fetchCurrenciesDic } from "../../store/slices/rtkDictionaries";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";

const TenantsAdminContainer: React.FC<tenantsAdminData> = () => {
  const dispatch = useDispatch();
  const { tenant, tenantLoading } = useSelector((state: RootStateOrAny) => state?.tenantsAdmin);
  const { dicCurrenciesLoading } = useSelector((state: RootStateOrAny) => state.rtkDictionaries);

  useEffect(() => {
    const tenantId = Number(LocalStorageService.getTenantId());
    dispatch(fetchTenant(tenantId));
    if (!checkIsLoaded(dicCurrenciesLoading)) dispatch(fetchCurrenciesDic());
  }, []);

  return (
    <>
      <div className="container_height">
        <TenantsAdmin tenant={tenant} tenantLoading={tenantLoading} />
      </div>
    </>
  );
};

export default TenantsAdminContainer;
